import React, { useMemo } from 'react'
import { PayTypeEnum } from "types/enum"
import { payTypeToCurrencySymbol } from 'utils/utils'
import style from "./index.module.scss"
import { RechargeStatus } from "."

interface GoodsInfoProps {
  goodsData: any
  curPay: PayTypeEnum | null
  coupon?: any
  pay?: any
  status?: any
}


const GoodsInfo: React.FC<GoodsInfoProps> = ({ goodsData, curPay, coupon, pay, status }) => {


  const Calculate = () => {
    if(!localStorage.links){
      return <></>
    }
    if(!JSON.parse(localStorage.links).url){
      return <></>
    }
    // if(JSON.parse(localStorage.links).url.default_discount_code){
    //   return (
    //     <span className={style.couponPrices}>
    //       {payTypeToCurrencySymbol(curPay)}
    //       {goodsData.present_price} - {(JSON.parse(localStorage.links).url.default_discount_code.split('_')[1] * (goodsData.present_price * 100)) / 10000} =
    //       <span className={style.couponColor}> {payTypeToCurrencySymbol(curPay)}{(goodsData.present_price * (100 -(JSON.parse(localStorage.links).url.default_discount_code.split('_')[1]))) / 100}</span>
    //     </span>
    //   )
    // }
    return (
      <span>
        {payTypeToCurrencySymbol(curPay)}
        {goodsData.present_price}
      </span>
    )
  }

  return useMemo(
    () => (
      <div className={style["goods-data"]}>
        {/* && (curPay || isWidthMobile()) */}
        {(goodsData.service_days)
          ? (<div>
            {/* <span className={style["service-days"]}>{`${goodsData.service_days}天VIP`}</span>
              - - - - */}
            <span className={style["goods-data-money"]}>
              {/* {
                `${payTypeToCurrencySymbol(curPay)}${coupon.discount ?  <div>{goodsData.present_price} x {((100- coupon.discount*100))}% = {payTypeToCurrencySymbol(curPay)}{(goodsData.present_price * (100-coupon.discount*100))/100}</div> : goodsData.present_price}`
              } */}
              {
                pay === 'wx_wap' && status === RechargeStatus.loading ? <span style={{ fontSize:16 }}>跳转微信小程序购买</span> :
                  localStorage.UserInfo ? (coupon.discount ? <span className={style.couponPrices}>
                    {payTypeToCurrencySymbol(curPay)}
                    {goodsData.present_price} - {((coupon.discount * 100) * (goodsData.present_price * 100)) / 10000} =
                    <span className={style.couponColor}> {payTypeToCurrencySymbol(curPay)}{(goodsData.present_price * (100 - coupon.discount * 100)) / 100}</span>
                  </span> : <span>
                    {payTypeToCurrencySymbol(curPay)}
                    {goodsData.present_price}
                  </span>) : (
                    coupon.discount ? <span className={style.couponPrices}>
                      {payTypeToCurrencySymbol(curPay)}
                      {goodsData.present_price} - {((coupon.discount * 100) * (goodsData.present_price * 100)) / 10000} =
                      <span className={style.couponColor}> {payTypeToCurrencySymbol(curPay)}{(goodsData.present_price * (100 - coupon.discount * 100)) / 100}</span>
                    </span> : <Calculate />
                  )
              }
            </span>
          </div>)
          : '- - - - - - - - -'}
      </div>
    ),
    [pay,status, curPay, goodsData.present_price, goodsData.service_days, coupon],
  )
}

export default GoodsInfo
